/* Short-lived upload tokens for the Feral upload proxy.
 *
 * Replaces a long-lived shared key that used to sit in page source, where
 * anyone could read it and push files into the store's Shopify Files. Tokens
 * are minted server-side, expire in five minutes, and are only issued to
 * requests coming from a Feral origin.
 *
 * Shared by sections/ferrule-configurator.liquid and sections/feral-build.liquid.
 * Lives here rather than inline because feral-build.liquid is within a kilobyte
 * of Shopify's 256 KB per-section limit.
 */
window.KYRO_TOKEN_ENDPOINT = 'https://feral-upload-api.vercel.app/api/token';

window.kyroUploadHeaders = (function () {
  var cached = null; // { token, exp }
  return async function () {
    var now = Date.now() / 1000;
    if (!cached || cached.exp - now < 30) {
      var res = await fetch(window.KYRO_TOKEN_ENDPOINT, { credentials: 'omit' });
      var json = await res.json();
      if (!json || !json.success || !json.token) throw new Error('upload token refused');
      cached = { token: json.token, exp: now + (json.expiresIn || 300) };
    }
    return { 'Content-Type': 'application/json', 'x-feral-upload-token': cached.token };
  };
})();
